import generateContext, { createAction } from '..';
import { IUser } from '../current-user';

interface IKeycloakUserState {
  keycloakToken: string;
  restaurant: IUser | null;
  isStateLoaded: boolean;
}

const initialState: IKeycloakUserState = {
  keycloakToken: '',
  restaurant: null,
  isStateLoaded: false,
};

enum KeycloakUserActionType {
  SetKeycloakToken = 'SET_KEYCLOAK_TOKEN',
  SetKeycloakRestaurantData = 'SET_KEYCLOAK_RESTAURANT_DATA',
  UpdateLoadingState = 'UPDATE_LOADING_STATE',
}

const reducer = (
  state: IKeycloakUserState,
  action: { type: KeycloakUserActionType; payload?: any }
): IKeycloakUserState => {
  switch (action.type) {
    case KeycloakUserActionType.SetKeycloakToken:
      return {
        ...state,
        keycloakToken: action.payload,
      };

    case KeycloakUserActionType.SetKeycloakRestaurantData:
      return {
        ...state,
        restaurant: action.payload,
        isStateLoaded: true,
      };

    case KeycloakUserActionType.UpdateLoadingState:
      return {
        ...state,
        isStateLoaded: action.payload,
      };
    default:
      return state;
  }
};

const [KeycloakUserCtxProvider, useKeycloakUserState, useKeycloakUserDispatch] =
  generateContext(reducer, initialState);

const useKeycloakUserActions = () => {
  const dispatch = useKeycloakUserDispatch();

  const setKeycloakToken = (payload: string) => {
    dispatch(createAction(KeycloakUserActionType.SetKeycloakToken, payload));
  };

  const setKeycloakRestaurantData = (payload: IUser) => {
    dispatch(
      createAction(KeycloakUserActionType.SetKeycloakRestaurantData, payload)
    );
  };

  const updateLoadingState = (payload: boolean) => {
    dispatch(createAction(KeycloakUserActionType.UpdateLoadingState, payload));
  };

  return {
    setKeycloakToken,
    setKeycloakRestaurantData,
    updateLoadingState,
  };
};

export {
  KeycloakUserCtxProvider,
  useKeycloakUserState,
  useKeycloakUserActions,
};
